import styled from 'styled-components';

enum breakpointSizes {
  xSmallMin = '0px',
  // Small tablets and large smartphones-{landscape view}
  smallMin = '576px',
  // Small tablets-{portrait view}
  mediumMin = '768px',
  // Tablets and small desktops
  largeMin = '992px',
  // Large tablets and desktops
  xLargeMin = '1200px',
  // Extra-Large tablets and desktops
  xxLargeMin = '1400px',
}

const breakpointValues = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
} as const;

const mediaQueries = {
  sm_up: `@media (min-width: ${breakpointSizes.smallMin})`,
  md_up: `@media (min-width: ${breakpointSizes.mediumMin})`,
  lg_up: `@media (min-width: ${breakpointSizes.largeMin})`,
  xl_up: `@media (min-width: ${breakpointSizes.xLargeMin})`,
  xxl_up: `@media (min-width: ${breakpointSizes.xxLargeMin})`,
  sm_only: `@media (min-width: ${breakpointSizes.smallMin}) and (max-width: ${breakpointSizes.mediumMin})`,
};

enum themeSizes {
  xs = '4px',
  sm = '8px',
  smMd = '12px',
  md = '16px',
  lg = '24px',
  xl = '32px',
  xxl = '48px',
  formFieldBottomMargin = '24px',
}

enum themeColors {
  primaryRed = '#dd0031',
  primaryWhite = '#fff',

  // Secondary Pallette
  secondaryBlue = '#004f71',

  // Tertiary Palette
  tertiaryGreen = '#249e6b',

  // Hover / Pressed States
  secondaryBlueHover = '#003e59',
  secondaryBluePressed = '#002b3e',
  primaryRedHover = '#9d0023',
  primaryRedPressed = '#7a001b',
  destructiveHover = '#64041a',
  destructivePressed = '#4C0314',

  // Semantic Colors
  errorColor = '#b6072f',
  warningColor = '#fbc111',
  successColor = '#077e4c',
  destructiveColor = '#810521',

  // Grayscale
  colorGray_1 = '#ecedee',
  colorGray_2 = '#cccfd0',
  colorGray_3 = '#a7acaf',
  colorGray_4 = '#93989b',
  colorGray_5 = '#80878c',
  colorGray_6 = '#5b6770',
  colorGray_7 = '#37424a',
  colorGray_8 = '#1e272f',

  // Custom Colors
  heroBackgroundColor = '#fcf6ef',
  notificationBackgroundColor = '#f7f8f8',
  colorBlack = '#000',
  inputFieldBackgroundColor = '#f8e6ea',
  fieldErrorBackgroundColor = '#f8e6eaff',
  fieldDisabledBackgroundColor = '#f8f8f8',
  reactCoreDisabledBackgroundColor = '#EBEBEB',
  cardBackgroundPressed = '#F7F8F8',
  focus = '#3EB1C8',
  CTAMenuBackgroundColor = '#f7f9fa',
  searchButtonBackground = '#ccdce3',
  selectOptionSelected = '#cfdce3',
  selectOptionHover = '#f2f6f8',
  selectOptionSelectedHover = '#b7c9d4',
}

const kbColorOptions = {
  '#808080': themeColors.colorGray_6,
  '#999999': themeColors.colorGray_6,
  '#95a5a6': themeColors.colorGray_6,
  '#7e8c8d': themeColors.colorGray_6,
  '#ff0000': themeColors.primaryRed,
};

const RedirectLoader = styled.div`
  display: flex;
  align-items: center;
  padding: ${themeSizes.xl} 0 ${themeSizes.lg} 0;
  flex-direction: column;

  h4 {
    color: ${themeColors.colorGray_6} !important;
    margin-top: ${themeSizes.md};
  }

  .cfa-loading-indicator {
    svg {
      height: 28px;
    }

    .cfa-loading-logo {
      left: 21%;
      top: 22%;
    }

    .cfa-loading-circlegraph-page-sm {
      height: ${themeSizes.xxl};
      width: ${themeSizes.xxl};

      .cfa-loading-dot {
        transform-origin: ${themeSizes.lg} 0;
      }
    }
  }
`;

export {
  breakpointSizes,
  breakpointValues,
  mediaQueries,
  RedirectLoader,
  themeColors,
  themeSizes,
  kbColorOptions,
};
